import styled from "styled-components";

export const StyledEditComment = styled.div`
  ${({ theme }) => `
    .edit-comment {
      .MuiPaper-root {
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
        background-color: transparent;
      }
      .edit-button-close {
        position: absolute;
        right: 0;
        top: -50px;
        padding: ${theme.uptimeSpace[6]}px;
        border-radius: 50%;
        color: ${theme.uptimeColors.mainTheme.primary};
      }
      .MuiTextField-root {
        width: 100%;
        .MuiInput-underline {
          &:before {
            border-bottom: 1px solid ${theme.uptimeColors.mainTheme.primary};
          }
          &:hover:before {
            border-bottom: 2px solid ${theme.uptimeColors.mainTheme.primary};
          }
        }
      }
      .edit-comment-btn {
        margin-top: ${theme.uptimeSpace[2]}px;
        display: flex;
        justify-content: flex-end;
        .hlx-btn {
          &:last-child {
            margin-left: ${theme.uptimeSpace[5]}px;
          }
        }
      }
      p {
        margin: ${theme.uptimeSpace[0]}px;
      }
      .MuiPaper-elevation1 {
        box-shadow: none;
      }
    }
    `
  }
`;
